export const BIRDVIEW_ATTENTION_WIDGET_SKELETON_ROWS_COUNT = 3
